import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import createCommunityAppService from '../../services/communityApps/createCommunityAppService';
import CommunityAppDetail from './CommunityAppDetail';
import { COMMUNITY_DETAIL_TABS } from '../../constants';
import { mapCommunityApp } from '../../helpers/mapCommunityApp';

const NewCommunityApp = ({ open, dispatchCreateCommunityAppPost, createCommunityAppFetch }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const communityTag = useSelector(state => get(state, 'repository.community.value.tag'));
  const appInstallationTag = useSelector(state =>
    get(state, 'repository.appInstallation.value.tag')
  );

  const handleSubmit = useCallback(
    body => {
      dispatchCreateCommunityAppPost(
        mapCommunityApp(body, appInstallationTag, communityTag),
        () => navigate(`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.APPS}`),
        t
      );
    },
    [dispatchCreateCommunityAppPost, appInstallationTag, communityTag, t, id, navigate]
  );

  if (!open) return null;

  return (
    <CommunityAppDetail
      header={t('newCommunityApp')}
      onSubmit={handleSubmit}
      submitProcessing={createCommunityAppFetch.pending}
      returnRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.APPS}`}
      cancelRoute={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.APPS}`}
      // TEMPORARY UNTIL WE CAN SWITCH TO TAG IN BROWSER PATH
      data={{
        community: {
          tag: communityTag,
        },
      }}
    />
  );
};

NewCommunityApp.propTypes = {
  dispatchCreateCommunityAppPost: PropTypes.func.isRequired,
  createCommunityAppFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewCommunityApp.defaultProps = { open: false };

export default createCommunityAppService(NewCommunityApp);
